import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

function ListHelperText(props: { children: React.ReactNode }) {
  const { children } = props;
  return <Text variant="body2">{children}</Text>;
}

function ListHelperItem(props: { children: React.ReactNode }) {
  const { children } = props;
  return (
    <Stack direction="row" spacing={1}>
      <Box>
        <CbhIcon type="dot" size="xSmall" />
      </Box>
      {children}
    </Stack>
  );
}

export function ListHelper(props: { children: React.ReactNode }) {
  const { children } = props;
  return <Stack spacing={3}>{children}</Stack>;
}

ListHelper.Item = ListHelperItem;
ListHelper.Text = ListHelperText;
